// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_OrderCanceled_box-lhq-e8x"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Sale/order-canceled/components/OrderCanceled.scss
// module id = 1888
// module chunks = 0